import React, { useState } from "react";
import { useLoader } from "../../Common/GeneralLoader/GeneralLoaderProvider";
import { addRecipientApi } from "../../../api/api";
import { drupalSettings } from "../../../utils/config";

export const RecipientSummaryConfirmDetails = ({ setStep, payload, setPayload }) => {
  const { showLoader, hideLoader } = useLoader(); // Destructure isLoading, showLoader, and hideLoader
  const [error, setError] = useState(false);

  const formErrors = {
    technical_error: Drupal.t(
      "Sorry, there was an error. Please try again later or reach out to support@nautzero.com."
    ),
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let isValid = true; // Flag to track if all validations pass

    // If any validation failed, prevent form submission
    if (!isValid) {
      return;
    }

    setError(false);

    showLoader();

    const requestPayload = {
      payload: { ...payload?.beneficiaryFormData },
      recipient_name: payload?.beneficiaryFormData?.beneficiary?.bank_details?.account_name,
      uid: drupalSettings?.user?.user_id || drupalSettings?.user?.uid,
    };

    (async () => {
      try {
        const response = await addRecipientApi(requestPayload);
        // SCA required: same handling as AddRecipientFlow ConfirmDetails (step 2.0 → 2.1)
        if (!response?.result && response?.message?.code === 403) {
          const scaSessionCode =
            response?.message?.sca_session_code ??
            response?.message?.session_code ??
            response?.message?.scaSessionCode ??
            response?.sca_session_code;
          if (scaSessionCode) {
            setPayload((prev) => ({
              ...prev,
              scaSessionCode,
              _addRecipientRequest: requestPayload,
            }));
            setStep(3.22);
            return;
          }
        }
        if (!response?.result) {
          setError(formErrors?.technical_error);
          return;
        }
        setPayload({ ...payload, recipientId: response?.beneficiary_id });
        setStep(5.2);
      } catch (err) {
        const scaSessionCode =
          err?.response?.headers?.["x-sca-session-code"] ??
          err?.response?.data?.message?.sca_session_code ??
          err?.response?.data?.message?.session_code ??
          err?.response?.data?.sca_session_code;
        if (err?.response?.status === 403 && scaSessionCode) {
          setPayload((prev) => ({
            ...prev,
            scaSessionCode,
            _addRecipientRequest: requestPayload,
          }));
          setStep(3.22);
          return;
        }
        setError(formErrors?.technical_error);
      } finally {
        hideLoader();
      }
    })();
  };

  return (
    <>
      <div className="create-transfer-header">
        <h4 className="create-transfer-title">
          Recipient <span className="yellow">Summary</span>
        </h4>
      </div>
      <div className="create-transfer-body-content">
        <form className="confirm-details-form">
          <div className="form--item form--group">
            <label>Recipient Type:</label>
            <strong>{payload?.beneficiaryFormData?.beneficiary?.entity_type}</strong>
          </div>
          {
            Object.entries(payload?.beneficiaryFormData?.beneficiary?.bank_details || {}).map(([key, value]) => {
              if (key.startsWith("account_routing_type")) {
                // extract the index (e.g., 1, 2...) to match with value
                const index = key.replace("account_routing_type", "");
                let typeLabel = "";
                if (value == "aba" || value == "iban") {
                  typeLabel = value.toUpperCase();
                }
                else {
                  typeLabel = value.split("_")
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" "); // like "bank_code"
                }
                const typeValue = payload?.beneficiaryFormData?.beneficiary?.bank_details?.[`account_routing_value${index}`];

                return (
                  <div key={key} className="form--item form--group">
                    <label>{typeLabel == "ABA" ? "Account Routing Number" : typeLabel}:</label>
                    <strong>{typeValue}</strong>
                  </div>
                );
              }

              // skip the "value" keys since they are already paired above
              if (key.startsWith("account_routing_value")) return null;

              let label = "";
              if (key == "iban") {
                // special case for IBAN
                label = key.toUpperCase();
              }
              else {
                // normal fields
                label = key
                  .split("_")
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ");
              }

              return (
                <div key={key} className="form--item form--group">
                  <label>{label}:</label>
                  <strong>{value}</strong>
                </div>
              );
            })
          }
          <div className="form--item form--group">
            <label>Recipient's Address:</label>
            <strong>
              {payload?.beneficiaryFormData?.beneficiary?.address ? Object.values(payload?.beneficiaryFormData?.beneficiary?.address)?.reverse()?.join(", ") : "--"}
            </strong>
          </div>
          {error && (
            <div className="popup-has-error">
              <div className="error_messages">{error}</div>
            </div>
          )}
          <div className="create-transfer-actions">
            <button className="secondary__btn" type="submit" onClick={() => setStep(2.2)}>
              Edit
            </button>
            <button className="primary__btn" type="submit" onClick={handleSubmit}>
              Confirm
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
